import React from 'react';
import { useTranslator } from '@front-activerse/common-components';
import ProviderDeviceChip from './ProviderDeviceChip';

interface Props {
  labelKey: string;
  unitKey?: string;
  value: number | null | undefined;
  provider?: string;
  device?: string | null;
}

const MetricValue: React.FC<Props> = ({ labelKey, unitKey, value, provider, device }) => {
  const { t } = useTranslator();
  const formatted = value === null || value === undefined ? '—' : String(value);
  return (
    <div data-testid={`metric-${labelKey}`} className="d-flex flex-column mb-3">
      <small className="text-muted">{t(labelKey)}</small>
      <span>
        <strong>{formatted}</strong>
        {unitKey && value !== null && value !== undefined ? <> {t(unitKey)}</> : null}
        {provider ? (
          <span className="ms-2">
            <ProviderDeviceChip provider={provider} device={device} />
          </span>
        ) : null}
      </span>
    </div>
  );
};

export default MetricValue;
